import { render, staticRenderFns } from "./NoItem.vue?vue&type=template&id=513da4b0&scoped=true&"
import script from "./NoItem.vue?vue&type=script&lang=ts&"
export * from "./NoItem.vue?vue&type=script&lang=ts&"
import style0 from "./NoItem.vue?vue&type=style&index=0&id=513da4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513da4b0",
  null
  
)

export default component.exports